import { QueryParams } from './queryGroups';

export const groupKeys = {
  groups: (params: QueryParams) => ['GROUPS', params] as const,
};
